<div class="ui padded segment">
  <h4 class="ui header">
    Price Calculator - ₹{{ screenPricePerSecond }} / sec
  </h4>
  <div class="ui segment">
    <div class="ui divided two column grid">
      <div class="row">
        <div class="column">
          <label>Impression/Hr</label>
          <div class="ui transparent fluid large rounded input">
            <input
              type="number"
              min="1"
              step="1"
              placeholder="Impression Count"
              onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
              [(ngModel)]="impressionsPerHour"
              (change)="calculateScreenPricing()"
            />
          </div>
        </div>
        <div class="column">
          <label>Ad(Seconds)</label>
          <div class="ui transparent fluid large rounded input">
            <input
              type="number"
              min="1"
              step="1"
              onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
              placeholder="Ad Duration"
              [(ngModel)]="adDuration"
              (change)="calculateScreenPricing()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui divided one column grid">
      <div class="row">
        <div class="column">
          <label
            >Every Day: <br />
            {{ impressionsPerDay }} Impressions - ({{
              timePerDay | number: '1.2-2'
            }}
            hrs of exposure)</label
          >
        </div>
      </div>
    </div>
  </div>
  <div class="ui segment">
    <div class="ui divided one column grid">
      <div class="row">
        <div class="column">
          <label
            >Every Month: <br />
            {{ impressionsPerMonth }} Impressions - ({{
              timePerDay * 30 | number: '1.2-2'
            }}
            hrs of exposure)</label
          >
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="ui inverted no border segment">
      <div class="ui middle aligned two column grid">
        <div class="row">
          <div class="column">
            <h3 class="ui inverted header">
              ₹ {{ totalPrice | number: '1.2-2' }}
            </h3>
          </div>
          <div class="column right aligned">Total Cost/Month</div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <div class="text grey">
    * Assuming store is open for {{ storeHoursPerDay }} hours
  </div>
</div>
